var map = {
	"./blog.yml": 121,
	"./cloud.yml": 122,
	"./color.yml": 123,
	"./country.yml": 124,
	"./dio.yml": 125,
	"./doc.yml": 126,
	"./emoji.yml": 127,
	"./git.yml": 128,
	"./icon.yml": 129,
	"./license.yml": 130,
	"./link.yml": 131,
	"./metrics.yml": 132,
	"./people.yml": 133,
	"./soft.yml": 134,
	"./src.yml": 135,
	"./status.yml": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;